import { fetcher } from "helpers/fetcher";

import { TUpdateParticipantInsuranceReq } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateEmployeeParticipantInsurance = async (
  payload: TUpdateParticipantInsuranceReq
) => {
  return await fetcher<
    TUpdateParticipantInsuranceReq,
    TUpdateParticipantInsuranceReq["data"]
  >(ENDPOINT.USER.UPDATE_EMPLOYEE_PARTICIPANT_INSURANCE, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.USER.UPDATE_EMPLOYEE_PARTICIPANT_INSURANCE.version,
      [API_HEADER.USER_ID]: payload.idUser,
    },
  });
};

export const mutationUpdateEmployeeParticipantInsurance = async (
  payload: TUpdateParticipantInsuranceReq
) => {
  return (await updateEmployeeParticipantInsurance(payload)).data;
};

mutationUpdateEmployeeParticipantInsurance._key = (
  payload: TUpdateParticipantInsuranceReq
) => [ENDPOINT.USER.UPDATE_EMPLOYEE_PARTICIPANT_INSURANCE.url, payload];
